import React, { useContext, useEffect, useRef, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@mui/material';
import { Box, Typography, Grid } from '@mui/material';
import { FaPrint } from "react-icons/fa";
import { AddActionsButton } from '../../../Components/AddElementsButton';
import { errorAlert } from '../../../Components/Alerts';
import authHeader from '../../../Auth/authHeader';
import { ApiLink } from '../../../APILink/ApiLink';
import axios from 'axios';
import { FiscalYearContext } from '../../../FiscalYear/FiscalYearContext';

const NenetComponent = (props) => {
    return (
        <CardHeader
            title={
                <Typography style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1rem', lineHeight: '1.75rem' }} >
                    {props.title}
                </Typography>
            }
        />
    )
}
const ContractDisplay = ({ contractData, name, idnumber, empAddress }) => {
    const tableRef = useRef();
    const headers = authHeader();

    const { fiscalYear } = useContext(FiscalYearContext);
    const [companyName, setCompanyName] = useState("");
    const [companyIDNumber, setCompanyIDNumber] = useState('');
    const [companyAddress, setCompanyAddress] = useState('');
    const [companyEmail, setCompanyEmail] = useState("");


    // Funksioni për marrjen e të dhënave të kompanisë
    const fetchCompaniesData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + "Companies/getCompanyDetails", { headers });
            setCompanyName(response.data[0].CompanyName);
            setCompanyAddress(response.data[0].Address);
            setCompanyIDNumber(response.data[0].IdentificationNumber);
            setCompanyEmail(response.data[0].Email);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    // Thirr fetchCompaniesData vetëm një herë kur komponenti ngarkohet
    useEffect(() => {
        fetchCompaniesData();
    }, []);

    // Nëse nuk ka të dhëna kontrate, mos shfaq gjë
    if (!contractData) {
        return null;
    }

    // Funksioni për printim i tabelës
    const handlePrint = () => {
        const table = tableRef.current;

        if (!table) {
            errorAlert("Nuk ka të dhëna për të gjeneruar kontratën.");
            return;
        }

        const printWindow = window.open("", "PrintWindow", "height=400,width=600");

        if (!printWindow) {
            console.error("Print window could not be opened.");
            return;
        }

        printWindow.document.open();
        printWindow.document.write(`
        <html>
        <head>
            <title>${`CON-${fiscalYear}-${contractData.contractNumber} - ${name}`}</title>
            <style>
                table {
                    width: 100%;
                    border-collapse: collapse;
                }
                table, th, td {
                    border: 1px solid black;
                }
                th, td {
                    padding: 8px;
                    text-align: left;
                }
            </style>
        </head>
        <body>
            ${table.outerHTML}
        </body>
        </html>
      `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };

    // Funksion për formatimin e datës në formatin lokal
    const formatDate = (dateString) => {
        if (!dateString) return '';

        const date = new Date(dateString);
        if (isNaN(date)) return '';

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Muajt fillojnë nga 0
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const formatDatePlusDays = (dateString, daysToAdd = 0) => {
        if (!dateString) return '';

        const date = new Date(dateString);
        if (isNaN(date)) return '';

        // Shto ditët
        date.setDate(date.getDate() + daysToAdd);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    const formatNumber = (value) =>
        new Intl.NumberFormat('sq-XK', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);

    return (
        <div>
            <AddActionsButton
                text="Print"
                onClick={handlePrint}
                icon={<FaPrint />}
                className="button-15"
            />
            {/* <Box ref={tableRef} sx={{ margin: 'auto', mt: 4, boxShadow: 3, borderRadius: 2 }}> */}
            <Box ref={tableRef} style={{ margin: 'auto', boxShadow: "3px", borderRadius: "2px" }}>
                <Card style={{ padding: "10%" }}>
                    <CardHeader
                        title={
                            <Typography style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '0.9rem', lineHeight: '1.75rem' }}>
                                {`Numri i Kontratës: CON-${fiscalYear}-${contractData.contractNumber}`}
                            </Typography>
                        }
                    />
                    <CardContent>
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Në bazë të nenit 10 paragrafi 2, pikat 2.1 dhe 2.2, dhe nenit 11 të Ligjit të Punës Nr. 03/L-212  i
                            shpallur në Gazetën Zyrtare të Republikës së Kosovës, më dt. 01.12.2010, Punëdhënësi dhe i Punësuari,
                            si subjekte të marrëdhënies juridike të punës, lidhin:
                        </Typography>
                    </CardContent>
                    <CardHeader
                        title={
                            <Typography style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1.rem', lineHeight: '2rem' }}>
                                KONTRATË PUNE
                                <br></br>
                                PËR
                                <br></br>
                                {contractData.contractType}
                            </Typography>
                        }
                    />
                    <CardContent>
                        <NenetComponent title="Neni 1" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Me këtë Kontratë: {companyName}, me numer fiskal: {companyIDNumber} dhe Adresë në {companyAddress},
                            të cilin e përfaqëson: {contractData.authorizedSignatory} (në tekstin e mëtejshëm: Punëdhënësi),  lidhë kontratë pune  me: {name} me nr. Personal {idnumber} dhe adresë në {empAddress}.
                        </Typography>

                        <NenetComponent title="Neni 2" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Pozita e të punësuarit është: {contractData.position},  në departmentin: {contractData.department}<br></br>
                            I punësuari do të kryej këto detyra të punës: {contractData.jobDuties}
                        </Typography>

                        <NenetComponent title="Neni 3" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I punësuari do të kryejë punët në {companyName} ne {companyAddress}.
                        </Typography>

                        <NenetComponent title="Neni 4" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I punësuari themelon marrëdhënie pune, në:<br></br>
                            {
                                contractData.contractType === "KOHË TË PACAKTUAR" ?
                                    <Typography paragraph>
                                        kohë të pacaktuar, duke filluar nga: {formatDate(contractData.startDate)}.
                                    </Typography>
                                    :
                                    <Typography paragraph>
                                        kohë të caktuar, duke filluar nga: {formatDate(contractData.startDate)}, deri më: {formatDate(contractData.endDate)}.
                                    </Typography>
                            }
                        </Typography>

                        <NenetComponent title="Neni 5" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I punësuari është i detyruar të fillojë punën, më: {formatDate(contractData.startDate)}.
                            <br></br>
                            <br></br>
                            Në rast se i punësuari nuk e fillon punën ditën e caktuar sipas kësaj Kontrate të Punës,
                            do të konsiderohet se nuk ka themeluar marrëdhënie pune,
                            përveç nëse është penguar të fillojë punën për shkaqe të arsyeshme.
                        </Typography>

                        <NenetComponent title="Neni 6" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Puna provuese e të punësuarit zgjat deri më: {formatDatePlusDays(contractData.startDate, 5)}. Gjatë periudhës provuese të punës,
                            punëdhënësi dhe i punësuari,
                            mund ta ndërpresin marrëdhënien e punës, me njoftim  paraprak prej shtatë (7) ditësh.
                        </Typography>

                        <NenetComponent title="Neni 7" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I punësuari themelon marrëdhënie pune me orar të pjesshëm. Orari i punës gjatë ditës është: {Number(contractData.workingHoursPerWeek) / 5} orë, ndërsa: {contractData.workingHoursPerWeek} orë në javë.
                            Aktiviteti i të punësuarit do të jetë brenda dhe jashtë shtetit të Kosovës.
                        </Typography>

                        <NenetComponent title="Neni 8" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Të punësuarit i caktohet paga bazë për punën të cilën e kryen për punëdhënësin,
                            në lartësi prej: {formatNumber(contractData.salaryGross)}€ Bruto ({formatNumber(contractData.salaryNet)}€ Neto) {contractData.employeeRole},
                            së paku një herë në muaj e cila nuk mund të jetë më e ulët se paga minimale.
                        </Typography>

                        <NenetComponent title="Neni 9" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I punësuari ka të drejtë në pagë shtesë në përqindje të pagës bazë:<br></br><br></br>
                            1)  20% në orë për kujdestari; <br></br>
                            2)  30% në orë për punë gjatë natës; <br></br>
                            3)  30% në orë për punë jashtë orarit; <br></br>
                            4)  50% në orë për punë gjatë ditëve të festave, dhe <br></br>
                            5)  50% në orë për punë gjatë fundjavës. <br></br>
                        </Typography>

                        <NenetComponent title="Neni 10" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I  punësuari ka të drejtë në  kompensim të pagës pa u angazhuar në punë, në rastet si në vijim:<br></br><br></br>
                            1)	gjatë ditëve të festave në të cilat nuk punohet; <br></br>
                            2)  gjatë kohës së shfrytëzimit të pushimit vjetor; <br></br>
                            3)	gjatë aftësimit dhe përsosjes profesionale për të cilën është dërguar dhe <br></br>
                            4)	gjatë ushtrimit të funksioneve publike për të cilat nuk paguhet. <br></br>
                        </Typography>

                        <NenetComponent title="Neni 11" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I punësuari ka të drejtë në kompensim të pushimit mjekësor të pagës bazë, prej:<br></br><br></br>
                            1)  100% në rast të shfrytëzimit të pushimit mjekësor të rregullt, mbi bazën deri në 20 ditë pune brenda një (1) viti;   <br></br>
                            2)  70% në rast të shfrytëzimit të pushimin mjekësor si pasojë e lëndimit në punë ose sëmundjes profesionale, e cila ndërlidhet me kryerjen e punëve dhe të shërbimeve për punëdhënësin,  në kohëzgjatje prej dhjetë (10) deri në nëntëdhjetë (90) ditë pune. <br></br>
                        </Typography>

                        <NenetComponent title="Neni 12" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I punësuari ka të drejtë në kompensim të shpenzimeve gjatë kohës së kaluar në udhëtim zyrtar jashtë vendit,  në lartësi prej: {contractData.foreignTravelCompensation}€.
                        </Typography>

                        <NenetComponent title="Neni 13" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I punësuari ka të drejtë në  pushim, dhe atë:<br></br><br></br>
                            1) pushim gjatë ditës së punës në kohëzgjatje prej së paku 30 minutash, në përputhje
                            organizimin e orarit të punës së punëdhënësit;
                            <br></br>
                            2) pushim ditor në kohëzgjatje prej së paku dymbëdhjetë (12) orë pandërprerë, midis dy (2)
                            ditëve të njëpasnjëshme të punës;
                            <br></br>
                            3) pushim javor në kohëzgjatje prej njëzetekatër (24) orë pandërprerë; <br></br>
                            4) pushim vjetor në kohëzgjatje së paku 4 javë;  <br></br>
                            5)	i punësuari i cili përkundër masave mbrojtëse  nuk mund të mbrohet nga ndikimet e
                            jashtme, ka të drejtë në pushim shtesë vjetor në kohëzgjatje prej tridhjetë ditësh (30) pune
                            për vitin kalendarik;
                            <br></br>
                            6)	nëna me fëmijë deri në tri (3) vjeç, prindi vetushqyes dhe personat me aftësi të  kufizuara kanë të drejtë në pushim vjetor shtesë edhe për dy (2) ditë të tjera.
                        </Typography>

                        <NenetComponent title="Neni 14" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I punësuari i cili për herë të parë themelon marrëdhënie pune ose i cili nuk ka
                            ndërprerje më tepër se pesë (5) ditë pune, ka të drejtën e shfrytëzimit të pushimit vjetor pas gjashtë (6) muajve të punës së pandërprerë.
                        </Typography>

                        <NenetComponent title="Neni 15" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I punësuari ka të drejtë së paku një ditë e gjysmë (1.5) të pushimit, për çdo muaj kalendarik të kaluar në punë, nëse: <br></br><br></br>
                            1) në vitin kalendarik në të cilin për herë të parë ka themeluar marrëdhënie pune, nuk i ka
                            gjashtë (6) muaj  të punës së pandërprerë;
                            <br></br>
                            2) në vitin kalendarik nuk e ka fituar të drejtën për shfrytëzimin e pushimit vjetor për shkak të
                            ndërprerjes së marrëdhënies së punës.
                            <br></br>
                        </Typography>

                        <NenetComponent title="Neni 16" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            I punësuari është përgjegjës për kompensimin e dëmit për punën ose në lidhje me punën, nëse me qëllim ose nga pakujdesia i ka shkaktuar dëm punëdhënësit.
                            <br></br>
                            I punësuari është përgjegjës edhe për kompensimin e dëmit, nëse me fajin e tij i ka shkaktuar dëm palës së tretë, dëm për të cilin punëdhënësi  e ka kompensuar.
                            <br></br>
                        </Typography>

                        <NenetComponent title="Neni 17" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Të punësuarit i ndërprehet marrëdhënia e punës nga punëdhënësi, nëse:<br></br><br></br>
                            1)	ndërprerja e tillë arsyetohet  për arsye ekonomike, teknike ose organizative;<br></br>
                            2)	i punësuari nuk është më i aftë të kryejë detyrat e punës; <br></br>
                            3)	në rastet e rënda të sjelljes së keqe të të punësuarit; <br></br>
                            4)	për shkak të mospërmbushjes së pakënaqshme të detyrave të punës, dhe  <br></br>
                            5)	për rastet e tjera të cilat janë përcaktuar me Ligjin e Punës.   <br></br>
                        </Typography>

                        <NenetComponent title="Neni 18" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Punëdhënësi obligohet të sigurojë dhe të zbatojë mjetet dhe masat e mbrojtjes në punë, sipas legjislacionit në fuqi
                            <br></br>
                            I punësuari është i detyruar t’iu përmbahet masave të caktuara të mbrojtjes në punë.                        <br></br>
                        </Typography>

                        <NenetComponent title="Neni 19" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Punëdhënësi obligohet t’i paguajë kontributet për skemat pensionale të obligueshme dhe skemat e tjera të përcaktuara me Ligj.
                        </Typography>

                        <NenetComponent title="Neni 20" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Punëdhënësi dhe i punësuari i pranojnë të gjitha të drejtat, detyrimet dhe përgjegjësitë e caktuara me Ligj, me Kontratë Kolektive dhe me këtë Kontratë.
                        </Typography>

                        <NenetComponent title="Neni 21" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Për kontestet eventuale të moszbatimit të kësaj Kontrate, palët kontraktuese e pranojnë kompetencën e Gjykatës Komunale.
                        </Typography>

                        <NenetComponent title="Neni 22" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Secila palë mund ta shkëpusë këtë Kontratë në mënyrë të njëanshme, sipas kushteve dhe rasteve të caktuara me Ligj dhe me Kontratë Kolektive.
                        </Typography>

                        <NenetComponent title="Neni 23" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Në asnjë rast, dispozitat e kësaj Kontrate nuk mund të jenë më pak të favorshme për të punësuarin dhe punëdhënësit, se dispozitat e Ligjit të Punës ose të Kontratës Kolektive, për sa u përket të drejtave dhe kushteve nga marrëdhënia juridike e punës.
                            Për të drejtat dhe detyrimet të cilat nuk janë përcaktuar me këtë Kontratë, zbatohen drejtpërdrejt dispozitat e Ligjit të Punës dhe të Kontratës Kolektive.
                        </Typography>

                        <NenetComponent title="Neni 24" />
                        <Typography paragraph style={{ fontSize: "14px" }}>
                            Pas njoftimit me përmbajtjen e Kontratës, kjo Kontratë nga palët kontraktuese u nënshkrua më datën: {formatDate(contractData.contractSignedDate)}, në: Zyret e {companyName}, në 4 kopje autentike, nga të cilat, secilës palë i mbeten nga dy kopje.
                        </Typography>

                        {/* <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: 4 }}> */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '32px' }}>
                            <Grid item xs={5} sx={{ textAlign: 'center' }}>
                                <Typography mt={1}>Punëdhënësi:</Typography>
                                <br></br>
                                <Typography mt={1}>____________________________</Typography>
                                {companyName}<br></br>
                                {contractData.authorizedSignatory}
                            </Grid>
                            <Grid item xs={5} sx={{ textAlign: 'center' }}>
                                <Typography mt={1}>I punësuari:</Typography>
                                <br></br>
                                <Typography mt={1}>____________________________</Typography>
                                {name}
                            </Grid>
                        </div>
                    </CardContent>
                </Card>
            </Box>
        </div >
    );
};

export default ContractDisplay;
